<template lang="pug">
  div(class="key-value-data")
    div(class="text-14px") {{ item.key }}
    component(
      v-if="item.component"
      :is="item.component"
      v-bind="item.componentProps"
    )
    div(
      v-else
      class="text-14px dark"
    ) {{ item.value }}
</template>

<script>
import EDocumentsStatus from '~/modules/documents/components/elements/e-documents-status'

export default {
  name: 'TKeyValueData',
  components: {
    EDocumentsStatus
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped lang="scss">
.key-value-data {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  padding: 12px;

  &:not(:last-child) {
    border-bottom: 1px solid #e3e3e3;
  }
}
</style>
